import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FHEDivider } from 'data/components';
import { withRouter } from 'react-router-dom';
import renderEnvComponent from 'data/common/renderEnvComponent';

class TableDetails extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
        managementId: PropTypes.number.isRequired,
        table: PropTypes.func.isRequired
    };

    render() {
        const { title, table: TableComponent, icon: IconComponent, managementId } = this.props;

        return (
            <Fragment>
                <FHEDivider title={title} IconComponent={IconComponent} />
                <TableComponent managementId={managementId} />
            </Fragment>
        );
    }
}

export default withRouter(renderEnvComponent('scenes/Management/Table/TableDetails', TableDetails));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/Table/TableDetails.js